exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--kJKzEug2AzyrL_JdjZAlD {\n  position: relative;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.5rem;\n  letter-spacing: .1px;\n  color: #373939;\n  width: 100%;\n  margin-top: -20px;\n  margin-bottom: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"modalSubtitle": "provider-panel--kJKzEug2AzyrL_JdjZAlD",
	"modalSubtitle": "provider-panel--kJKzEug2AzyrL_JdjZAlD"
};